const upButton = document.querySelector('.j-up-button');
const currentUrl = window.location.href;

if (upButton && (currentUrl.includes('sales') || currentUrl.includes('kvartiry'))) {
    const check = () => {
        if (window.pageYOffset > 200) {
            upButton.classList.add('visible');
        } else {
            upButton.classList.remove('visible');
        }
    };

    const scrollToTop = () => {
        window.scroll({
            top     : 0,
            left    : 0,
            behavior: 'smooth'
        });
    };

    check();

    upButton.addEventListener('click', () => {
        scrollToTop();
    });

    window.addEventListener('scroll', () => {
        check();
    });
}
